import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { getFolders } from "../../context/fetch/fetchAssets";
import { useAssetsValue } from "../../context/reducers/assetsContext";
import LeftSide from "./LeftSide";
import RightSide from "./RightSide";
import useDebouncedSearch from "../../hooks/useDebouncedSearch";
import SearchInput from "../../core/SearchInput";
import {
  getAssetsSuccess,
  getFoldersSuccess,
  attemptGetFolders,
} from "../../context/actions/assetsActions";

const Main = (props) => {
  const [state, dispatch] = useAssetsValue();
  const { showInModal } = props;
  
  const initialState = useMemo(() => {
    return {
      columnName: "createdAt",
      sortAsc: true,
    };
  }, []);
  const [sortQuery, setSortValue] = useState(initialState);
  const { searchQuery, debouncedSearch, handleSearchChange, resetSearch } = useDebouncedSearch();

  useEffect(() => {
    let didCancel = false;

    const fetchFolders = async () => {
      dispatch(attemptGetFolders());
      try {
        const sort = `${sortQuery.columnName}:${sortQuery.sortAsc ? "asc" : "desc"}`;

        const result = await getFolders(
          showInModal,
          sort,
          state.folder.activeFolderId,
          debouncedSearch,
        );
        const { folders, activeFolderId, assets } = result;
        if (activeFolderId) {
          !didCancel && dispatch(getAssetsSuccess({ assets, id: activeFolderId }));
        }
        !didCancel && dispatch(getFoldersSuccess({ folders, activeFolderId }));
      } catch (error) {}
    };

    fetchFolders();
    return () => (didCancel = true);
  }, [dispatch, showInModal, sortQuery, debouncedSearch]);

  return (
    <>
      <Container className={"info-container"}>
        <Row className={"justify-content-start"}>
          <Col md={10} lg={8} className={"info-section assets-section"}>
            {!props.showInModal && (
              <div className="info-card">
                <p className={"info-title text-uppercase fbold"}>Asset Database</p>
                <p className={"info-text"}>
                  In your asset database you can load and store your logos, photos, illustrations
                  and sound files in your specific project folder. Add folder and subfolder and
                  just drag and drop your files.
                </p>
                <div className="info-details">
                  <div className="info-detail-item">
                    <span className="info-detail-label">Accepted image files</span>
                    <span>JPEG, PNG, GIF</span>
                  </div>
                  <div className="info-detail-item">
                    <span className="info-detail-label">Accepted audio files</span>
                    <span>MP2, MP3, MPGA</span>
                  </div>
                </div>
                <p className="info-warning">
                  Please regard that you only upload low-res image files with less than 5 MB
                </p>
              </div>
            )}
          </Col>
        </Row>
      </Container>
      <Container className={"editor-container"}>
        <div className="d-flex justify-content-end mb-3">
          <SearchInput
            value={searchQuery}
            onChange={handleSearchChange}
            onClear={resetSearch}
            placeholder="Search files..."
          />
        </div>
        <div className={"overview-editor templates-view"}>
          <Row className={"justify-content-start"}>
            <Col>
              <div className={"editor-view assets-view"}>
                <Row className={"justify-content-start"}>
                  <Col col={12}>
                    <div className={"file-editor"}>
                      <div
                        className={`align-items-stretch d-flex flex-column flex-lg-row h-100 ${
                          state.folder.file.isAssetsLoading ? "eventDisabled" : ""
                        }`}
                      >
                        <LeftSide {...props} sortQuery={sortQuery} debouncedSearch={debouncedSearch} />
                        <RightSide
                          sortQuery={sortQuery}
                          setSortValue={setSortValue}
                          searchQuery={searchQuery}
                          handleSearchChange={handleSearchChange}
                          resetSearch={resetSearch}
                          {...props}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default Main;
